import { z } from "zod";
import { moneyField, optionalText, optionalUuid, quantityField } from "./common.js";
export const expenseCategorySchema = z.object({
    key: z.string().trim().min(1, "Key is required.").max(24),
    name: z.string().trim().min(1, "Name is required.").max(120),
});
export const invoiceLineSchema = z.object({
    description: z.string().trim().min(1, "Description is required.").max(300),
    quantity: quantityField,
    unitPrice: moneyField,
});
export const invoiceCreateSchema = z.object({
    customerId: z.string().uuid("Invalid customer id."),
    salesOrderId: optionalUuid(),
    notes: optionalText(4000),
    lines: z.array(invoiceLineSchema).min(1, "Add at least one line.").max(100).optional(),
});
export const invoiceIssueSchema = z.object({
    dueDate: z.string().date().optional(),
});
export const invoiceVoidSchema = z.object({
    reason: z.string().trim().min(3, "A short reason is required.").max(500),
});
export const paymentSchema = z.object({
    customerId: z.string().uuid("Invalid customer id."),
    invoiceId: optionalUuid(),
    amount: moneyField,
    method: optionalText(40),
    reference: optionalText(120),
});
export const paymentReverseSchema = z.object({
    reason: z.string().trim().min(3, "A short reason is required.").max(500),
});
export const expenseSchema = z.object({
    categoryId: z.string().uuid("Invalid category id."),
    amount: moneyField,
    description: optionalText(500),
    method: optionalText(40),
    reference: optionalText(120),
    occurredAt: z.string().datetime({ offset: true }).optional(),
});
export const cashQuerySchema = z.object({
    direction: z.enum(["in", "out"]).optional(),
    categoryId: z.string().uuid().optional(),
    from: z.string().date().optional(),
    to: z.string().date().optional(),
    limit: z.coerce.number().int().min(1).max(500).default(200),
});
export const invoiceListQuerySchema = z.object({
    status: z
        .enum(["draft", "issued", "partially_paid", "paid", "overdue", "void"])
        .optional(),
    customerId: z.string().uuid().optional(),
});
export const invoiceIdParamSchema = z.object({
    id: z.string().uuid("Invalid invoice id."),
});
export const paymentIdParamSchema = z.object({
    paymentId: z.string().uuid("Invalid payment id."),
});
export const cashTransactionIdParamSchema = z.object({
    transactionId: z.string().uuid("Invalid transaction id."),
});
export const expenseCategoryIdParamSchema = z.object({
    categoryId: z.string().uuid("Invalid category id."),
});
//# sourceMappingURL=finance.js.map